import { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { Route, Routes } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { FallbackWithLogo } from 'shared/ui';
import { useSaveServiceParams } from 'legacy/lib';

import { RECEIPT_DETAIL_LOADING_TEXT } from './Detail/config';
import { Detail, Expired, Issue, ReceiptDetailGateway } from './Detail/ui';
import { ReceiptBarcode, ReceiptPage } from './MedicalReceipt/ui';

export const Receipt = () => {
  const serviceParams = useBoundStore((state) => state['medicalReceipt'].serviceParams);

  useSaveServiceParams('medicalReceipt', serviceParams);

  return (
    <Routes>
      <Route
        path='/'
        element={
          <Suspense>
            <Helmet>
              <meta name='viewport' content='width=1400,maximum-scale=1.0,user-scalable=no,viewport-fit=cover' />
            </Helmet>
            <ReceiptPage />
          </Suspense>
        }
      />
      <Route
        path='/barcode'
        element={
          <>
            <Helmet>
              <meta
                name='viewport'
                content='width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover'
              />
            </Helmet>
            <ReceiptBarcode />
          </>
        }
      />
      {/* 진료비 세부 내역서 */}
      <Route
        path='/issue'
        element={
          <Suspense
            fallback={<FallbackWithLogo title={RECEIPT_DETAIL_LOADING_TEXT.CHECK} subTitle='잠시만 기다려주세요.' />}
          >
            <Issue />
          </Suspense>
        }
      />
      <Route path='/expired' element={<Expired />} />
      <Route
        path='/detail'
        element={
          <Suspense
            fallback={<FallbackWithLogo title={RECEIPT_DETAIL_LOADING_TEXT.CHECK} subTitle='잠시만 기다려주세요.' />}
          >
            <ReceiptDetailGateway />
          </Suspense>
        }
      />
    </Routes>
  );
};
